<template>
    <main>
        <div class="autocomplete">
            <input :placeholder="placeholder" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter="onEnter()" v-model="searchMap" @input="searchList()" class="form-control J-search-map w-100">
            <ul class="autocomplete-results" v-show="isOpen" style="position:fixed;width:200px"  v-click-outside="closeOpen"> 
                <li class="loading" v-if="isLoading">
                    Loading results...
                </li>
                <li class="autocomplete-result" v-else v-for="(result, i) in results" :key="i" @click="setResult(result)" :class="{ 'active': i === arrowCounter }" data-toggle="tooltip" :title="result.name">
                    {{ result.name.slice(0,23) }}...
                </li>
            </ul>
        </div>
    </main>
</template>
<script>
import ClickOutside from 'vue-click-outside'
import { EventBus } from '@/helpers/eventbus/event-bus'
import {CompanyService} from '@/services'
export default {
    data(){
        return{
            searchMap:'',
            search:{
                descripcion:'',
            },
            items:[],
            searchProveedorEntidad:'',
            searchProductoCat:'',

            results: [],
            arrowCounter: -1,
            isLoading:false,
            isOpen: false,
            isAsync:false,
        }
    },
    directives: {
        ClickOutside
    },
    props:{
        placeholder:{type:String,default:'Buscar'}
    },
    mounted(){
        
    },
    methods:{
        closeOpen:function(){
            this.isOpen = false;
        },
        keyChange:function(){
            this.$emit('keyChange',this.searchMap)
        },
        filter:function(item,list){
            return list.filter(function(el){
                return el.id.indexOf(item)>-1;
            });
        },
        searchList:function(){
            this.keyChange()

            if (this.isAsync) {
                this.isLoading = true;
            } else {
                // Data is sync, we can search our flat array
                this.filterResults();
                this.isOpen = true;
            }
        },
        setResult(result) {
            this.keyChange()    
            this.selected(result);
            var map=result.name.trim();
            this.searchMap = map;
            this.isOpen = false;
        
          },
        filterResults() {
            this.results = this.items.filter(item => {
                var map=item.name.replace(',','');
                
                return this.getCleanedString(map).indexOf(this.getCleanedString(this.searchMap)) > -1;
            });
            if(this.results.length==0){
                this.listar(this.searchMap);
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter() {
            var map=this.results[this.arrowCounter];
            this.selected(map)
            this.searchMap = map.name;
            this.isOpen = false;
            this.arrowCounter = -1;
        },
        selected:function(data){
            this.$emit('selected',data)
        },
        listar:async function(valor){
            var query={
                'q':valor,
            }
            const results =await CompanyService.search(query);
            if(results.status==200){
                //console.log(results.data.data);

                this.items=results.data.data;
                this.results=this.items;
                this.isOpen=true;
            }
            
            
        }
    }
}
</script>
